import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tab } from 'component/base'
import { Custom } from 'component/pieces'

export const Iraisha = props => {
  const { multiple, setSelectedId, selectedId } = props

  const [loading, setLoading] = useState(false)

  return (
    <Tab
      panes={[
        {
          menuItem: '一般得意先',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Tokuisaki
                mode='iraisha'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
                loading={loading}
                setLoading={setLoading}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: '運送店',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Kumiaiin
                mode='iraisha'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: '単組他',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.TansoSeikyuShiharaisaki
                mode='torihikisaki'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
                loading={loading}
                setLoading={setLoading}
              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  )
}

Iraisha.propTypes = {
  multiple: PropTypes.bool,
  setSelectedId: PropTypes.func,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Iraisha.defaultProps = {
  multiple: false,
  setSelectedId: () => {},
  selectedId: undefined,
}
